import React, { useState, useEffect, useRef } from "react";
import SideBar from "./SideBar";
import Header from "./Header";
import { SlHome } from "react-icons/sl";
import { SlArrowRight } from "react-icons/sl";
import { useLocation } from "react-router-dom";
import {
  getOfflineOrderImagesAPI,
  getOfflineOrderSelectedCategoryImagesAPI,
  getCategorySubMenusAPI,
  GetCategoryImagesAPI,
  deleteCategoryImages,
  updateCategoryImages,
  UpdateFlipLinkUrlAPI,
  getCategoryMenuData,
  paperTypeSelectedOption,
  createOfflineOrdersAPI,
  sendPaymentLinkMailAPI
} from "../../serverApi/server";
import { FaEdit } from "react-icons/fa";
import { MultiSelect } from "primereact/multiselect";
import Skeleton from '../skeleton/Skeleton';
import { FiCopy } from 'react-icons/fi';
import { decryptToken } from "../../components/Helper/Helpers";
import { MdGeneratingTokens } from "react-icons/md";
import { IoMdMail } from "react-icons/io";
import { FaSpinner } from "react-icons/fa";


const OfflineOrderImages = () => {
  const location = useLocation();
  const [allCategories, setAllCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getOfflineOrderImages();
  }, []);

  const getOfflineOrderImages = async () => {
    const getOfflineOrderImagesAPIResponse = await getOfflineOrderImagesAPI();
    if (getOfflineOrderImagesAPIResponse.data.client_status_code === 200) {
      setAllCategories(getOfflineOrderImagesAPIResponse.data.all_header_menus_details);
    } else {
      setAllCategories([]);
    }
  };

  const headerMenus = location.state || [];
  const [categoryList, setCategoryList] = useState([]);
  const [editCategoryId, setEditCategoryId] = useState("");
  const [editImageId, setEditImageId] = useState("");
  const [isZoomed, setIsZoomed] = useState(false);
  const [subMenuList, setSubMenuList] = useState("");
  const [formCategoryList, setFormCategoryList] = useState([]);
  const formheaderMenus = location.state || [];
  const [formSubMenuList, setFormSubMenuList] = useState("");
  const [flipLink, setFlipLink] = useState("");

  const [selectedCategory, setSelectedCategory] = useState(
    headerMenus.find((menu) => menu.additional_name === "memorial_funeral")
      ?.id || ""
  );

  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [selectedMemorialCategoryId, setSelectedMemorialCategoryId] = useState([]);
  const [selectedMarketingEssentialsCategoryId, setSelectedMarketingEssentialsCategoryId] = useState([]);
  const [selectedSerivesCategoryId, setSelectedSerivesCategoryId] = useState([]);

  const memorialFuneralGroup = allCategories.find((groupObj) =>
    Object.keys(groupObj)[0] === "Memorial/Funeral"
  );

  const groupedMemorialCategories = memorialFuneralGroup
    ? [
        {
          label: "Memorial/Funeral",
          items: memorialFuneralGroup["Memorial/Funeral"].map((cat) => ({
            label: cat.category,
            value: cat.id,
          })),
        },
      ]
    : [];


  // const groupedMarketingAndServicesCategories = allCategories
  //   .filter((groupObj) => {
  //     const groupName = Object.keys(groupObj)[0];
  //     return groupName === "Marketing Essentials" || groupName === "Services";
  //   })
  //   .map((groupObj) => {
  //     const [groupName, categories] = Object.entries(groupObj)[0];
  //     return {
  //       label: groupName,
  //       items: categories.map((cat) => ({
  //         label: cat.category,
  //         value: cat.id,
  //       })),
  //   };
  // });


  const marketingEssentialsGroup = allCategories.find((groupObj) =>
    Object.keys(groupObj)[0] === "Marketing Essentials"
  );

  const groupedmarketingEssentialsCategories = marketingEssentialsGroup
    ? [
        {
          label: "Marketing Essentials",
          items: marketingEssentialsGroup["Marketing Essentials"].map((cat) => ({
            label: cat.category,
            value: cat.id,
          })),
        },
      ]
    : [];


  const ServicesGroup = allCategories.find((groupObj) =>
    Object.keys(groupObj)[0] === "Services"
  );

  const groupedServicesCategories = ServicesGroup
    ? [
        {
          label: "Services",
          items: ServicesGroup["Services"].map((cat) => ({
            label: cat.category,
            value: cat.id,
          })),
        },
      ]
    : [];

  const groupHeaderTemplate = (group) => {
    return <div className="font-bold text-primary">{group.label}</div>;
  };

  const handleMemorialCategoryChange = async (e) => {
    const selectedIds = e.value;
    await setSelectedMemorialCategoryId(selectedIds);
  };

  const handleMarketingEssentialsCategoryChange = async (e) => {
    const selectedIds = e.value;
    await setSelectedMarketingEssentialsCategoryId(selectedIds);
  };

  const handleServicesCategoryChange = async (e) => {
    const selectedIds = e.value;
    await setSelectedSerivesCategoryId(selectedIds);
  };

  useEffect(()=>{
    const mergedIds = [...selectedMemorialCategoryId, ...selectedMarketingEssentialsCategoryId, ...selectedSerivesCategoryId];
    setSelectedCategoryIds(mergedIds);
  }, [selectedMemorialCategoryId, selectedMarketingEssentialsCategoryId, selectedSerivesCategoryId])

  const handleGroupCategoryChange = (id) => {
    const numericId = parseInt(id);
    setSelectedCategoryIds((prev) =>
      prev.includes(numericId) ? prev : [...prev, numericId]
    );
  };

  const [selectedOfflineCategoryImages, setSelectedOfflineCategoryImages] = useState([]);

  const getOfflineSelectedCategoryImages = async () => {
    const getOfflineOrderSelectedCategoryImagesAPIResponse =
      await getOfflineOrderSelectedCategoryImagesAPI(selectedCategoryIds);
    if (
      getOfflineOrderSelectedCategoryImagesAPIResponse.data
        .client_status_code === 200
    ) {

      setSelectedOfflineCategoryImages(
        getOfflineOrderSelectedCategoryImagesAPIResponse.data
          .category_menu_images_serializer
      );
    } else {
      setSelectedOfflineCategoryImages([]);
    }
  };

    const toggleForm = () => setFormOpen(!formOpen);
    const [formOpen, setFormOpen] = useState(false);
    const [clickedItems, setClickedItems] = useState([]);
    const [selectedCategoryMenuImagesList, setSelectedCategoryMenuImagesList] = useState([]);
    const [selectedOptionsCategoryImagesList, setSelectedOptionsCategoryImagesList] = useState({});
    const [formFields, setFormFields] = useState([]);
    const [categoryPermissionFields, setCategoryPermissionFields] = useState();
    const [placeOrderValidationStatus, setPlaceOrderValidationStatus] = useState(false);
    const [numberOfPadsDetailsList, setNumberOfPadsDetailsList] = useState();

    const handleImageClick = (categoryImageMenu) => {
      setPlaceOrderValidationStatus(false);
      const id = categoryImageMenu.id;
      setClickedItems((prevItems) => {
          const exists = prevItems.find((item) => item.id === id);
          if (exists) {
          return prevItems.filter((item) => item.id !== id);
          } else {
          return [...prevItems, categoryImageMenu];
          }
      });
    };

    const fetchData = async (categoryMenuId) => {
        try {
            const data = await getCategoryMenuData(categoryMenuId);
            return data
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const placeOfflineOrder = async () => {
      if (clickedItems.length > 0) {
        const allData = [];
        for (const item of clickedItems) {
            try {
                const data = await fetchData(item.id);
                allData.push(data);
            } catch (error) {
                console.error(`Error fetching data for ID ${item.id}:`, error);
            }
        }

        setSelectedCategoryMenuImagesList(allData);
        const allFormFields = allData.map(item => item.form_fields_serializer);
        const flatFormFields = allFormFields.flat();

        const numberOfPadsField = flatFormFields.find(
          field => field.additional_name === "number_of_pads"
        );
        const numberOfPadsDetailsList = numberOfPadsField?.options || [];
        setNumberOfPadsDetailsList(numberOfPadsDetailsList)

        setFormFields(flatFormFields);
        const categoryPermissionFieldsData = allData.map(item => ({
            [item.category_id]: item.category_permission_fields
        }));
        setCategoryPermissionFields(categoryPermissionFieldsData);
        toggleForm()
        return;
      }
      setPlaceOrderValidationStatus(true);
      return;
    };

    const [numbering, setNumbering] = useState(false)
    const [numberingInk, setNumberingInk] = useState(false);
    const [padding, setPadding] = useState(false);
    const [numberOfSet, setNumberOfSet] = useState(false);
    const [perNumberOfPads, setPerNumberOfPads] = useState([]);
    const [numberOfPadsOption, setNumberOfPadsOption] = useState(null)
    const [ticketPaperColor, setTicketPaperColor] = useState(false);
    const [envelopeSize , setEnvelopeSize] = useState(false);
    const [colorCopiesSellSheets , setColorCopiesSellSheets] = useState(false);
    const [numberOfPads, setNumberOfPads] = useState(0)
    const [brouchers, setBrouchers] = useState(false);
    const [additionalName, setAdditionalName] = useState();
    const fieldTipRef = useRef();
    const fieldTipButtonRef = useRef();
    const [openFieldTip, setOpenFieldTip] = useState(null);
    const [formData, setFormData] = useState({});
    const dropdownRef = useRef(null);
    const [showPriceTable, setShowPriceTable] = useState(false);
    const [subTitle, setSubTitle] = useState('');
    const [showPhotosPriceTable, setshowPhotosPriceTable] = useState(false);
    const [sizePaperType, setSizePaperType] = useState({});
    const [carbonlessFormDiscount, setCarbonlessFormDiscount] = useState('');
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0.00);
    const [currentEasternTime, setCurrentEasternTime] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [permissionFieldId, setPermissionFieldId] = useState('');
    const [quantityId, setQuantityId] = useState('');
    const [fieldSize, setFieldSize] = useState([]);
    const [selectedFormFieldsOptions, setSelectedFormFieldsOptions] = useState([]);
    const [fieldValidation, setFieldValidation] = useState(false);
    const [eachPrice, setEachPrice] = useState();
    const [isFieldValidation, setisFieldValidation] = useState(false);
    const [currentCategory, setCurrentCategory] = useState();

    const handleToggleFieldTip = (e, fieldName) => {
        e.preventDefault();
        setOpenFieldTip((prev) => (prev === fieldName ? null : fieldName));
    }

    const paperTypeSelectedOptionAPI = async (selectedOption, categoryId) => {
      try {
        const paperTypeSelectedOptionAPIResponse = await paperTypeSelectedOption(selectedOption);
        const serializer = paperTypeSelectedOptionAPIResponse.data.paper_type_field_amount_serializer;
        const updatedSelectedOptions = { ...selectedOptions };
        Object.entries(updatedSelectedOptions).forEach(([key, option]) => {
          const matchedSerializer = serializer.find(item => item.option === option.id);
          if (matchedSerializer) {
            updatedSelectedOptions[key] = {
              ...option,
              amount: matchedSerializer.amount,
            };
          }
        });

        const updatedFormFields = formFields.map((field) => {
          const updatedOptions = field.options.map((option) => {
            // Find matching serializer item based on option id
            const matchedSerializer = serializer.find(
              (s) => s.option === option.id
            );
        
            // If matched, add the amount to the option
            if (matchedSerializer) {
              return {
                ...option,
                amount: matchedSerializer.amount, // convert string to number
              };
            }
        
            // If no match, return option unchanged
            return option;
          });
        
          // Return updated field with updated options
          return {
            ...field,
            options: updatedOptions,
          };
        });

        // Update state or use updatedFormFields as needed
        setFormFields(updatedFormFields);
        
        // Update state
        setSelectedOptions(updatedSelectedOptions);

      } catch (error) {
        console.error('Error fetching sub-menus:', error);
      }
    };

    const findMatchingOption = (value, options) => {
        const matchedOption = options.find((option) => {
          var optionName = option.name.replace(/\s/g, '');
          const parts = option.name.split('to');
          if (parts.length !== 2) {
            return false;
          }
          const [start, end] = parts.map((n) => {
            const trimmed = n.trim();
            const num = Number(trimmed);
            return isNaN(num) ? null : num;
          });
    
          return start !== null && end !== null && value >= start && value <= end;
        });
    
        return matchedOption || null;
    }

    const handleChange = (e, fieldId, fieldName, selectedCategoryId) => {
        setCurrentCategory(selectedCategoryId)
        const matchedCategory = selectedCategoryMenuImagesList.find(
          (item) => item.category_id === selectedCategoryId
        );
        var carbonlessFormsadditionalName = matchedCategory?.category_additional_name
        setAdditionalName(matchedCategory?.category_additional_name)
        var additionalName = matchedCategory?.category_additional_name
        var { name, value, options, selectedIndex } = e.target;
        var name = `${name}_${fieldId}`;

        const selectedId = options?.[selectedIndex]?.getAttribute('data-id') || '';
        if (name === 'Size' || name === 'Paper Type') {
            setSizePaperType((prev) => ({
                ...prev,
                [name]: selectedId,
            }));
        }
        const field = formFields.find(f => f.id === fieldId);
        if (additionalName === 'carbonless_forms' && field.additional_name === 'sets_per_pad') {
            setNumberOfPadsOption(value)
            if (parseInt(value) === 25) {
                var dataFirst = [10, 20, 40, 60, 80, 100, 120, 160, 200, 240, 280, 320, 360, 400]
                const matchedOptions = numberOfPadsDetailsList.filter(item =>
                dataFirst.includes(parseInt(item.name))
                );
                const updatedCategoryMenuImagesList = selectedCategoryMenuImagesList.map(category => {
                  if (category.category_id === selectedCategoryId) {
                    const updatedFormFields = category.form_fields_serializer.map(field => {
                      if (field.additional_name === "number_of_pads") {
                        return {
                          ...field,
                          options: matchedOptions,
                        };
                      }
                      return field;
                    });
                
                    return {
                      ...category,
                      form_fields_serializer: updatedFormFields,
                    };
                  }
                  return category;
                });
                
                setSelectedCategoryMenuImagesList(updatedCategoryMenuImagesList);


                setFormFields(prevFields =>
                  prevFields.map(field =>
                      field.additional_name === "number_of_pads"
                      ? { ...field, options: matchedOptions }
                      : field
                  )
                );

            } else if (parseInt(value) === 50) {
                var dataSecond = [5, 10, 20, 30, 40, 50, 60, 80, 100, 120, 140, 160, 180, 200]
                const matchedOptions = numberOfPadsDetailsList.filter(item =>
                    dataSecond.includes(parseInt(item.name))
                );
                const updatedCategoryMenuImagesList = selectedCategoryMenuImagesList.map(category => {
                  if (category.category_id === selectedCategoryId) {
                    const updatedFormFields = category.form_fields_serializer.map(field => {
                      if (field.additional_name === "number_of_pads") {
                        return {
                          ...field,
                          options: matchedOptions,
                        };
                      }
                      return field;
                    });
                
                    return {
                      ...category,
                      form_fields_serializer: updatedFormFields,
                    };
                  }
                  return category;
                });
                
                setSelectedCategoryMenuImagesList(updatedCategoryMenuImagesList);
                setFormFields(prevFields =>
                    prevFields.map(field =>
                        field.additional_name === "number_of_pads"
                        ? { ...field, options: matchedOptions }
                        : field
                    )
                );

            } else if (parseInt(value) === 100) {
                var dataThird = [5, 10, 15, 20, 25, 30, 40, 50, 60, 70, 80, 90, 100]
                const matchedOptions = numberOfPadsDetailsList.filter(item =>
                    dataThird.includes(parseInt(item.name))
                );
                const updatedCategoryMenuImagesList = selectedCategoryMenuImagesList.map(category => {
                  if (category.category_id === selectedCategoryId) {
                    const updatedFormFields = category.form_fields_serializer.map(field => {
                      if (field.additional_name === "number_of_pads") {
                        return {
                          ...field,
                          options: matchedOptions,
                        };
                      }
                      return field;
                    });
                
                    return {
                      ...category,
                      form_fields_serializer: updatedFormFields,
                    };
                  }
                  return category;
                });
                
                setSelectedCategoryMenuImagesList(updatedCategoryMenuImagesList);
                setFormFields(prevFields =>
                    prevFields.map(field =>
                        field.additional_name === "number_of_pads"
                        ? { ...field, options: matchedOptions }
                        : field
                    )
                );

            }
        }

        if (field.quantity_calculation === true && field.additional_name === 'quantity') {
            if (value === '') {
                setFormData((prev) => ({
                    ...prev,
                    [name]: '',
                }));
                setSelectedOptions((prevSelectedOptions) => ({
                    ...prevSelectedOptions,
                    [fieldId]: null,
                }));
                setSelectedIds((prevIds) => prevIds.filter((id) => id !== fieldId));
                setTotalPrice(parseFloat(0.00).toFixed(2))
                return;
            }
            value = Math.max(1, Math.min(10000, Number(value) || 0));
            var selectedOption = findMatchingOption(value, field.options);
        } else {
            var selectedOption = field?.options?.find(option => option.name === value);
            if (fieldName.additional_name === 'print_turn_around') {
                const match = selectedOption.name.match(/^\d+/);
                var days = match ? parseInt(match[0], 10) : 0;
                var currentOptionDay = match ? parseInt(match[0], 10) : 0;
                const currentDateInEST = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
                const [currentDate, currentTime] = currentDateInEST.split(", ");
                const [hours, minutes, meridian] = currentTime.match(/(\d+):(\d+):\d+ (\w+)/).slice(1);
                const currentHourIn24 = meridian === "PM" && hours !== "12" ? parseInt(hours, 10) + 12 : parseInt(hours, 10);
                const currentMinutes = parseInt(minutes, 10);
                const dateObjectValue = new Date(currentDateInEST);
                const dayOfWeekDate = dateObjectValue.getDay();
                if (dayOfWeekDate !== 0 && dayOfWeekDate !== 6) {
                    if (currentHourIn24 > 11 && currentHourIn24 < 24) {
                        days = days + 1
                    } else if (currentHourIn24 === 11 && currentMinutes > 1) {
                        days = days + 1;
                    }
                }

                const dateObject = new Date(currentDateInEST);
                var orderDays = days

                if (days === 0) {
                    const dayOfWeek = dateObject.getDay();
                    if (dayOfWeek === 0) {
                        var sundayHoliday = 1 + days
                        dateObject.setDate(dateObject.getDate() + sundayHoliday);
                    } else if (dayOfWeek === 6) {
                        var sundayHoliday = 2 + days
                        dateObject.setDate(dateObject.getDate() + sundayHoliday);
                    } else {
                        dateObject.setDate(dateObject.getDate() + days);
                    }
                } else {
                    while (days > 0) {
                        dateObject.setDate(dateObject.getDate() + 1);
                        const dayOfWeek = dateObject.getDay();
                        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                        days--;
                        }
                    }
                }
                var weekEndOrderDate = new Date(currentDateInEST);
                var weekday = weekEndOrderDate.getDay();
                if ((orderDays !== 0) && (weekday === 0 || weekday === 6)) {
                    dateObject.setDate(dateObject.getDate() + 1);
                }
                const formattedDate = dateObject.toLocaleString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                });
                setCurrentEasternTime(formattedDate)
                setSelectedDate(dateObject)
            }
        }

        if (selectedOption) {
            selectedOption.calculation_status = field.calculation_status || false;
            selectedOption.quantity_calculation = field.quantity_calculation || false;
            selectedOption.full_field_name = field.field_name || '';
            selectedOption.position_id = field.position_field_id || 0;
        }

        if (fieldName && fieldName.field_name === 'Quantity') {
            selectedOption.category_additional_name = additionalName
            if (selectedOption && selectedOption.permissionFieldId) {
                setPermissionFieldId(selectedOption.permissionFieldId)
            }
            setFieldSize(prev => ({
              ...prev,
                [selectedCategoryId]: value
            }));
            setQuantityId(selectedOption.id)
        }
         
        if (additionalName === 'carbonless_forms' && fieldName && fieldName.additional_name === 'number_of_sets') {
            setFieldSize(prev => ({
              ...prev,
              [selectedCategoryId]: value
            }));
        } 

        if (additionalName === 'carbonless_forms' && fieldName && fieldName.additional_name === 'number_of_pads') {
            setNumberOfPads(value)
        }
    
        selectedOption.fieldName=fieldName.additional_name
        selectedOption.categoryId=selectedCategoryId

        setFormData({
            ...formData,
            [name]: value,
        });

        const selectedValueStr = categoryPermissionFields.find(obj =>
            Object.keys(obj)[0] == selectedCategoryId
        )?.[selectedCategoryId];
        
        const selectedValue = selectedValueStr.length > 0 ? JSON.parse(selectedValueStr) : [];

        if (selectedValue.includes(fieldId)) {
          setSelectedFormFieldsOptions(prev => ({
              ...prev,
              [selectedCategoryId]: {
                  ...(prev[selectedCategoryId] || {}),
                  [name]: selectedOption
              }
          }));
        }

        setSelectedOptions(prevSelectedOptions => ({
            ...prevSelectedOptions,
            [fieldId]: selectedOption,
        }));
        setSelectedIds(prevIds => {
        if (!prevIds.includes(fieldId)) {
            return [...prevIds, fieldId];
        }
        return prevIds;
        });

        if (fieldName.additional_name === 'numbering' && selectedOption.name === 'Numbering') {
            setNumbering(true)
        } else if (fieldName.additional_name === 'numbering' && selectedOption.name === 'No Numbering') {
            setNumbering(false)
            const ids = formFields
                .filter(field =>
                field.additional_name === 'numbering_ink' ||
                field.additional_name === 'starting_number' ||
                field.additional_name === 'numbering_location'
                )
                .map(field => field.id);
            setSelectedOptions(prevSelectedOptions => {
                const updatedOptions = { ...prevSelectedOptions };
                ids.forEach(id => {
                    if (updatedOptions[id]) {
                        delete updatedOptions[id];
                    }
                });
                return updatedOptions;
            });
            setSelectedIds(prevIds => {
                const updatedIds = prevIds.filter(id => !ids.includes(id));
                return updatedIds;
            });
            setFormData(prevFormData => {
                const updatedFormData = { ...prevFormData };
                ids.forEach(id => {
                    updatedFormData[formFields.find(field => field.id === id)?.field_name] = '';
                });
                return updatedFormData;
            });
        }

        if (fieldName.additional_name === 'numbering_ink' && selectedOption.name !== "None") {
            setNumberingInk(true)
        } else if (fieldName.additional_name === 'numbering_ink' && selectedOption.name === "None") {
            setNumberingInk(false)
            const ids = formFields
                .filter(field =>
                field.additional_name === 'starting_number' ||
                field.additional_name === 'numbering_location'
                )
                .map(field => field.id);
            setSelectedOptions(prevSelectedOptions => {
                const updatedOptions = { ...prevSelectedOptions };
                ids.forEach(id => {
                    if (updatedOptions[id]) {
                        delete updatedOptions[id];
                    }
                });
                return updatedOptions;
            });
            setSelectedIds(prevIds => {
                const updatedIds = prevIds.filter(id => !ids.includes(id));
                return updatedIds;
            });
            setFormData(prevFormData => {
                const updatedFormData = { ...prevFormData };
                ids.forEach(id => {
                    updatedFormData[formFields.find(field => field.id === id)?.field_name] = '';
                });
                return updatedFormData;
            });
        }

        if (fieldName.additional_name === 'padding' && selectedOption.name !== "Not Padded (Loose Sets)") {
            setNumberOfSet(false)
            setPadding(true)
            const ids = formFields
                .filter(field =>
                field.additional_name === "number_of_sets"
                )
                .map(field => field.id);

            setSelectedOptions(prevSelectedOptions => {
                const updatedOptions = { ...prevSelectedOptions };
                ids.forEach(id => {
                if (updatedOptions[id]) {
                    delete updatedOptions[id];
                }
                });
                return updatedOptions;
            });
            setSelectedIds(prevIds => {
                const updatedIds = prevIds.filter(id => !ids.includes(id));
                return updatedIds;
            });
            setFormData(prevFormData => {
                const updatedFormData = { ...prevFormData };
                ids.forEach(id => {
                updatedFormData[formFields.find(field => field.id === id)?.field_name] = '';
                });
                return updatedFormData;
            });

        } else if (fieldName.additional_name === 'padding' && selectedOption.name === "Not Padded (Loose Sets)") {
            setPadding(false)
            setNumberOfSet(true)
            setPerNumberOfPads([])
            const ids = formFields
                .filter(field =>
                field.additional_name === 'sets_per_pad' ||
                field.additional_name === 'number_of_pads' ||
                field.additional_name === 'number_of_sets'
                )
                .map(field => field.id);
            setSelectedOptions(prevSelectedOptions => {
                const updatedOptions = { ...prevSelectedOptions };
                ids.forEach(id => {
                if (updatedOptions[id]) {
                    delete updatedOptions[id];
                }
                });
                return updatedOptions;
            });
            setSelectedIds(prevIds => {
                const updatedIds = prevIds.filter(id => !ids.includes(id));
                return updatedIds;
            });
            setFormData(prevFormData => {
                const updatedFormData = { ...prevFormData };
                ids.forEach(id => {
                updatedFormData[formFields.find(field => field.id === id)?.field_name] = '';
                });
                return updatedFormData;
            });
        }

        if (additionalName === 'carbonless_forms' && field.additional_name === 'sets_per_pad' || field.additional_name === 'number_of_pads') {
            setPerNumberOfPads(prevState => {
                if (!prevState.includes(field.id)) {
                return [...prevState, field.id];
                }
                return prevState;
            });
        }
        if (additionalName === 'tickets' && fieldName.additional_name === 'color' && value === 'Full Color') {
            setTicketPaperColor(true)
            const ids = formFields
                .filter(field =>
                field.additional_name === "ticket_paper_color"
                )
                .map(field => field.id);
            setSelectedOptions(prevSelectedOptions => {
                const updatedOptions = { ...prevSelectedOptions };
                ids.forEach(id => {
                if (updatedOptions[id]) {
                    delete updatedOptions[id];
                }
                });
                return updatedOptions;
            });
            setSelectedIds(prevIds => {
                const updatedIds = prevIds.filter(id => !ids.includes(id));
                return updatedIds;
            });
            setFormData(prevFormData => {
                const updatedFormData = { ...prevFormData };
                ids.forEach(id => {
                updatedFormData[formFields.find(field => field.id === id)?.field_name] = '';
                });
                return updatedFormData;
            });
        } else if (additionalName === 'tickets' && fieldName.additional_name === 'color' && value === 'Black Ink') {
            setTicketPaperColor(false)
        }

        
        if (additionalName === 'envelopes'  && fieldName.additional_name === 'size' && value === 'Tithe Envelopes 3.625  x 6.5') {
            setEnvelopeSize(true)
            const ids = formFields
                .filter(field =>
                field.additional_name === 'window' ||
                field.additional_name === 'pull_&_seal'
                )
                .map(field => field.id);
            setSelectedOptions(prevSelectedOptions => {
                const updatedOptions = { ...prevSelectedOptions };
                ids.forEach(id => {
                if (updatedOptions[id]) {
                    delete updatedOptions[id];
                }
                });
                return updatedOptions;
            });
            setSelectedIds(prevIds => {
                const updatedIds = prevIds.filter(id => !ids.includes(id));
                return updatedIds;
            });
            setFormData(prevFormData => {
                const updatedFormData = { ...prevFormData };
                ids.forEach(id => {
                updatedFormData[formFields.find(field => field.id === id)?.field_name] = '';
                });
                return updatedFormData;
            });

        } else if (additionalName === 'envelopes'  && fieldName.additional_name === 'size' && value !== 'Tithe Envelopes 3.625  x 6.5') {
            setEnvelopeSize(false)
        }

        if (additionalName === 'flyer_5.5_x_8.5' && fieldName.additional_name === 'paper_type' && (value === '20lb Paper' || value === '28lb Hammermill White Paper')) {
            setColorCopiesSellSheets(true)
            const ids = formFields
                .filter(field =>
                field.additional_name === "edge_cutting"
                )
                .map(field => field.id);
            setSelectedOptions(prevSelectedOptions => {
                const updatedOptions = { ...prevSelectedOptions };
                ids.forEach(id => {
                if (updatedOptions[id]) {
                    delete updatedOptions[id];
                }
                });
                return updatedOptions;
            });
            setSelectedIds(prevIds => {
                const updatedIds = prevIds.filter(id => !ids.includes(id));
                return updatedIds;
            });
            setFormData(prevFormData => {
                const updatedFormData = { ...prevFormData };
                ids.forEach(id => {
                updatedFormData[formFields.find(field => field.id === id)?.field_name] = '';
                });
                return updatedFormData;
            });
        } else if (additionalName === 'flyer_5.5_x_8.5' && fieldName.additional_name === 'paper_type' && (value !== '20lb Paper' || value !== '28lb Hammermill White Paper')) {
            setColorCopiesSellSheets(false)
        }

        if (additionalName === 'brouchers' && fieldName.additional_name ==='paper_type' && (value === '70lb Opaque Text Matt' || value === '100lb Gloss Text' || value === '65lb Matt Cover')) {
            setBrouchers(true)
            const ids = formFields
                .filter(field =>
                field.additional_name === "finish"
                )
                .map(field => field.id);
            setSelectedOptions(prevSelectedOptions => {
                const updatedOptions = { ...prevSelectedOptions };
                ids.forEach(id => {
                if (updatedOptions[id]) {
                    delete updatedOptions[id];
                }
                });
                return updatedOptions;
            });
            setFormData(prevFormData => {
                const updatedFormData = { ...prevFormData };
                ids.forEach(id => {
                updatedFormData[formFields.find(field => field.id === id)?.field_name] = '';
                });
                return updatedFormData;
            });
        } else if (additionalName === 'brouchers' && fieldName.additional_name ==='paper_type' && (value !== '70lb Opaque Text Matt' || value !== '100lb Gloss Text' || value !== '65lb Matt Cover')) {
            setBrouchers(false)
            const ids = formFields
                .filter(field =>
                field.additional_name === "finish"
                )
                .map(field => field.id);
            setSelectedOptions(prevSelectedOptions => {
                const updatedOptions = { ...prevSelectedOptions };
                ids.forEach(id => {
                if (updatedOptions[id]) {
                    delete updatedOptions[id];
                }
                });
                return updatedOptions;
            });
            setFormData(prevFormData => {
                const updatedFormData = { ...prevFormData };
                ids.forEach(id => {
                updatedFormData[formFields.find(field => field.id === id)?.field_name] = '';
                });
                return updatedFormData;
            });
        }

        if (additionalName === 'carbonless_forms' && field.additional_name === 'number_of_sets') {
          setCarbonlessFormDiscount(selectedOption.discount ? selectedOption.discount : 0)
        }
    }

    useEffect(() => {
        if (perNumberOfPads.length == 2) {
          const namesAsIntegers = perNumberOfPads
            .map(id => {
              const option = selectedOptions[id];
              return option ? parseInt(option.name, 10) : null;
            })
            .filter(value => !isNaN(value));
    
          if (namesAsIntegers.length === 2) {
            const product = namesAsIntegers[0] * namesAsIntegers[1];
            var numberOfSets = formFields.find(f => f.additional_name === 'number_of_sets')
            var numberOfSetsOption = numberOfSets.options.find(option => option.name == product);
            if (numberOfSetsOption) {
              numberOfSetsOption.categoryId=numberOfSets.category
              numberOfSetsOption.fieldName=numberOfSets.additional_name
              // setFieldSize(numberOfSetsOption.name)
              setFieldSize(prev => ({
                ...prev,
                [numberOfSets.category]: numberOfSetsOption.name
              }));

              setFormData(prevState => {
                const key = `${numberOfSets.field_name}_${numberOfSets.id}`;
                if (prevState[numberOfSets.field_name] !== numberOfSetsOption.name) {
                  return {
                    ...prevState,
                    [key]: numberOfSetsOption.name,
                  };
                }
                return prevState;
              });
    
              setSelectedOptions(prevSelectedOptions => {
                if (prevSelectedOptions[numberOfSets.id]?.name !== numberOfSetsOption.name) {
                  return {
                    ...prevSelectedOptions,
                    [numberOfSets.id]: numberOfSetsOption,
                  };
                }
                return prevSelectedOptions;
              });
    
              setSelectedIds(prevIds => {
                if (!prevIds.includes(numberOfSets.id)) {
                  return [...prevIds, numberOfSets.id];
                }
                return prevIds;
              });
              setNumberOfSet(true)
              setCarbonlessFormDiscount(numberOfSetsOption.discount)
            }
    
            return;
    
          }
        }
    }, [perNumberOfPads, selectedOptions, formFields]);

    const [subTotal, setSubTotal] = useState();
    const [tax, setTax] = useState();
    const [balanceDue, setBalanceDue] = useState();
    const [grandTotal, setGrandTotal] = useState();
    const [newOrderId, setNewOrderId] = useState();
    const [newOfflinePaymentLinkId, setNewOfflinePaymentLinkId] = useState();
    

    const [paymentLinkURL, setPaymentLinkURL] = useState("");

    const [orderUserDetails, setOrderUserDetails] = useState({
      fullName: "",
      email: "",
      phone: "",
      address: "",
      city: "",
      state: "",
      zipCode: "",
      paymentMethod: "",
      CheckCreditCardNo: "",
      Depositamount: "",
      paymentMode: ""
    });
  
    const handleOrderUserDetails = (e) => {
      const { name, value, type, checked } = e.target;
      setOrderUserDetails((prev) => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      }));
    };


    useEffect(() => {
      if (orderUserDetails.paymentMode === 'credit_card') {
        setOrderUserDetails((prev) => ({
          ...prev,
          Depositamount: '',
          CheckCreditCardNo: '',
        }));
      } else {

      }
    }, [orderUserDetails.paymentMode]);

    useEffect(() => {
      const processOptions = async () => {
        const selectedOptionsByCategory = {};
    
        // Group selected options by categoryId
        Object.values(selectedOptions).forEach(option => {
          const categoryId = option.categoryId;
          if (!categoryId) return;
    
          if (!selectedOptionsByCategory[categoryId]) {
            selectedOptionsByCategory[categoryId] = [];
          }
    
          selectedOptionsByCategory[categoryId].push(option);
        });
    
        // for (const categoryId of Object.keys(selectedOptionsByCategory)) {
          try {    
            const matchedField = categoryPermissionFields.find(obj =>
              obj.hasOwnProperty(currentCategory)
            );
    
            const value = matchedField ? matchedField[currentCategory] : null;
            const startCategoryPermissionFields = value ? JSON.parse(value) : [];
    
            const endCategoryPermissionFields = selectedFormFieldsOptions[currentCategory];
            const selectedPriceCategory = selectedOptionsByCategory[currentCategory];
    
            // Ensure both sets are present and match in length
            if (
              Array.isArray(startCategoryPermissionFields) &&
              endCategoryPermissionFields &&
              Object.keys(endCategoryPermissionFields).length === startCategoryPermissionFields.length
            ) {
              await paperTypeSelectedOptionAPI(endCategoryPermissionFields, currentCategory);
            }
    
          } catch (error) {
            console.error(`Error processing category ${currentCategory}:`, error);
          }
        // }
      };
      processOptions();
    }, [selectedFormFieldsOptions, categoryPermissionFields]);

    useEffect(() => {
        const selectedOptionsByCategory = {};
        Object.values(selectedOptions).forEach(option => {
            const categoryId = option.categoryId;
            if (!categoryId) return;
            if (!selectedOptionsByCategory[categoryId]) {
              selectedOptionsByCategory[categoryId] = [];
            }
            selectedOptionsByCategory[categoryId].push(option);
        });

        if (Object.keys(selectedOptionsByCategory).length > 0) {
            const allcategoryImagesPrice = []

            for (const categoryId of Object.keys(selectedOptionsByCategory)) {
                try {
                    const selectedPriceCategory = selectedOptionsByCategory[categoryId];
                    
                    const currentCategory = selectedCategoryMenuImagesList.find(
                      category => String(category.category_id) === String(categoryId)
                    );

                    const selectedOptionsFinal = selectedPriceCategory.reduce((acc, item) => {
                      acc[item.Field] = item;
                      return acc;
                    }, {});
                    const totalAmount = Object.values(selectedPriceCategory).reduce((total, option) => {
                        var optionPrice = option.amount
                        if (option.calculation_status === true) {
                        optionPrice = option.amount * fieldSize[categoryId]
                        }
                        if (option.quantity_calculation === true) {
                        optionPrice = option.amount * fieldSize[categoryId]
                        }
                        if (currentCategory.category_additional_name === 'carbonless_forms' && option.fieldName === 'padding') {
                        optionPrice = option.amount * numberOfPads
                        }
                        return total + (parseFloat(optionPrice) || 0);
                    }, 0);
                    var formattedTotal = parseFloat(totalAmount).toFixed(2);

                    if (currentCategory.category_additional_name === 'carbonless_forms' && fieldSize[categoryId] !== '250' && carbonlessFormDiscount) {
                        var discountPercentage = parseFloat(carbonlessFormDiscount) / 100;
                        var discountAmount = (parseFloat(formattedTotal) * discountPercentage).toFixed(2);
                        formattedTotal = (formattedTotal - discountAmount).toFixed(2);
                    }
                    allcategoryImagesPrice.push({[categoryId]: formattedTotal})
                } catch (error) {
                    console.error(`Error processing category ${categoryId}:`, error);
                }
            }

            const matchedCategories = selectedCategoryMenuImagesList.map((category) => {
                const categoryId = category.category_id;
                const priceEntry = allcategoryImagesPrice.find(
                    (entry) => entry.hasOwnProperty(categoryId)
                );
                const price = priceEntry ? priceEntry[categoryId] : null;
                return {
                    ...category,
                    price: price,
                    category_menu_serilizer: {
                      ...category.category_menu_serilizer,
                      price: price,
                  },
                };
            });

            const totalPrice = allcategoryImagesPrice.reduce((sum, item) => {
              const value = parseFloat(Object.values(item)[0]) || 0;
              return sum + value;
            }, 0);
            if (Number(totalPrice.toFixed(2)) !== 0) {
              const taxAmount = (parseFloat(totalPrice).toFixed(2) * 8.875) / 100;
              const grandTotal = (parseFloat(totalPrice) + parseFloat(taxAmount)).toFixed(2)
              setSubTotal(parseFloat(totalPrice).toFixed(2))
              setTax(parseFloat(taxAmount).toFixed(2))
              const depositAmount = parseFloat(orderUserDetails.Depositamount) || 0.00;
              const balanceDue = parseFloat(grandTotal) - depositAmount;
              setBalanceDue(balanceDue.toFixed(2))
              setGrandTotal(parseFloat(grandTotal).toFixed(2))
            }
            setSelectedCategoryMenuImagesList(matchedCategories);
            setSelectedOptionsCategoryImagesList(selectedOptionsByCategory)
        }
    }, [selectedIds, selectedOptions, fieldSize, numberOfPads, carbonlessFormDiscount, orderUserDetails]);

  const submitUserOrder = async (e) => {
    e.preventDefault();
    try {
      const categoryMenuSerializerList = selectedCategoryMenuImagesList.map(item => item.category_menu_serilizer);
      const categorySelectedOptions = {};
      for (const [categoryId, items] of Object.entries(selectedOptionsCategoryImagesList)) {
        categorySelectedOptions[categoryId] = items.map(item => ({
          id: item.id,
          Field: item.Field,
          categoryId: item.categoryId
        }));
      }
      
      const createOfflineOrdersAPIResponse = await createOfflineOrdersAPI(categoryMenuSerializerList, categorySelectedOptions, orderUserDetails, subTotal, tax, balanceDue, grandTotal)      
      if(createOfflineOrdersAPIResponse.data && createOfflineOrdersAPIResponse.data.id === 2 && createOfflineOrdersAPIResponse.data.client_status_code === 200) {
        setNewOrderId(createOfflineOrdersAPIResponse.data.new_offline_order_id)
        setNewOfflinePaymentLinkId(createOfflineOrdersAPIResponse.data.new_offline_payment_link_id)
        setPaymentLinkURL(`https://stalbansprinting.com/billing-page?data=${createOfflineOrdersAPIResponse.data.payment_data}`)
        setOpenLinkInput(true);
      } else if(createOfflineOrdersAPIResponse.data && createOfflineOrdersAPIResponse.data.id === 1 && createOfflineOrdersAPIResponse.data.client_status_code === 200) {
        toggleForm();
      }

    } catch (error) {
      console.error("Error fetching sub-menus:", error);
    }
  }

  const [openLinkInput, setOpenLinkInput] = useState(false);

  const generateLink = (e) => {
    e.preventDefault();
    setOpenLinkInput(true);
    setPaymentLinkURL('http://localhost:3000/admin/offline_order_images?fullName=&email=&phone=&address=&city=&state=&zipCode=&paymentMode=credit_card')
  }

  const copyToClipboard = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(grandTotal);
  };

  const sendPaymentURLMail = async (e) => {
    e.preventDefault();
    var paymentType = 'deposit_amount'
    setLoading(true);
    await sendPaymentLinkMailAPI(newOrderId, newOfflinePaymentLinkId, paymentType)
    setLoading(false);
  }

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      marginTop: 0,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const handleSubMenuListChange = (e) => {
    setSubMenuList(e.target.value);
  };

  const fetchCategorySubMenus = async () => {
    try {
      const getCategorySubMenusAPIResponse = await getCategorySubMenusAPI(
        selectedCategory
      );
      setCategoryList(
        getCategorySubMenusAPIResponse.data.categories_serializer
      );
      const categories =
        getCategorySubMenusAPIResponse.data.categories_serializer;
      const defaultMenu =
        categories.length > 0 ? categories[0].additional_name : "";

      setSubMenuList(
        categories.find((menu) => menu.additional_name === "bookmarks")
          ?.additional_name || defaultMenu
      );
    } catch (error) {
      console.error("Error fetching sub-menus:", error);
    }
  };

  useEffect(() => {
    fetchCategorySubMenus();
  }, [selectedCategory]);

  const pageSize = 1000;
  const [totalPageAPI, setTotalPageAPI] = useState(null);
  const [currentPageAPI, setCurrentPageAPI] = useState(null);
  const [previousPageAPI, setPreviousPageAPI] = useState(null);
  const [nextPageAPI, setNextPageAPI] = useState(null);
  const [products, setProducts] = useState([]);

  const GetImageFileSize = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const sizeInBytes = blob.size;
      const sizeInKB = sizeInBytes / 1024;
      const sizeInMB = sizeInKB / 1024;

      return sizeInMB > 1
        ? `${sizeInMB.toFixed(2)} MB`
        : `${sizeInKB.toFixed(2)} KB`;
    } catch (error) {
      console.error("Error getting image size:", error);
      return "Error";
    }
  };

  const GetOurProductsCategoryImages = async (
    additionalName,
    page,
    pageSize
  ) => {
    const GetCategoryImagesApiResponse = await GetCategoryImagesAPI(
      additionalName,
      page,
      pageSize
    );
    if (
      GetCategoryImagesApiResponse.status === 200 &&
      GetCategoryImagesApiResponse.data &&
      GetCategoryImagesApiResponse.data.category_serializer.length !== 0
    ) {
      const categoryImages = await Promise.all(
        GetCategoryImagesApiResponse.data.category_serializer.map(
          async (item) => {
            const size = await GetImageFileSize(item.image_file);
            return { ...item, image_size: size };
          }
        )
      );
      setProducts(categoryImages);
      setCurrentPageAPI(GetCategoryImagesApiResponse.data.current_page);
      setTotalPageAPI(GetCategoryImagesApiResponse.data.total_pages);
      setPreviousPageAPI(GetCategoryImagesApiResponse.data.previous_page);
      setNextPageAPI(GetCategoryImagesApiResponse.data.next_page);
    } else {
      setProducts([]);
    }
  };

  const firstPage = 1;
  const [currentPage, setCurrentPage] = useState(currentPageAPI);

  const fetchCategoryImagesList = async (subMenuList) => {
    await GetOurProductsCategoryImages(subMenuList, firstPage, pageSize);
  };

  useEffect(() => {
    fetchCategoryImagesList(subMenuList);
  }, [subMenuList]);

  const [selectedFormHeader, setSelectedFormHeader] = useState(
    formheaderMenus.find((menu) => menu.additional_name === "memorial_funeral")
      ?.id || ""
  );
  const handleFormHeaderChange = (e) => {
    setSelectedFormHeader(e.target.value);
  };
  const handleFormSubMenuListChange = (e) => {
    setFormSubMenuList(e.target.value);
  };

  useEffect(() => {
    const fetchCategorySubMenus = async () => {
      try {
        const getCategorySubMenusAPIResponse = await getCategorySubMenusAPI(
          selectedFormHeader
        );
        setFormCategoryList(
          getCategorySubMenusAPIResponse.data.categories_serializer
        );
        setFormSubMenuList(
          getCategorySubMenusAPIResponse.data.categories_serializer.find(
            (menu) => menu.additional_name === "bookmarks"
          )?.id || ""
        );
      } catch (error) {
        console.error("Error fetching FORM-sub-menus:", error);
      }
    };
    if (selectedFormHeader) {
      fetchCategorySubMenus();
    }
  }, [selectedFormHeader]);

  const editCategoryImage = async () => {
    await updateCategoryImages(editImageId, formSubMenuList);
    fetchCategoryImagesList(subMenuList);
    toggleForm();
  };

  return (
    <div className="flex w-full h-screen">
      <div className="fixed h-full custom-scroll">
        <SideBar />
      </div>
      <div className="ml-64 flex-1 overflow-y-auto">
        <Header />
        <div className="bg-[#F5F7FD] px-7 py-6">
          <div className="flex items-center justify-between">
            <div className="text-blue-950 flex items-center gap-6">
              <h1 className="pr-6 text-2xl font-medium border-r">
                Admin Users
              </h1>
              <div className="flex text-sm items-center gap-3">
                <button>
                  <SlHome />
                </button>
                <SlArrowRight />
                <button>Offline Orders</button>
              </div>
            </div>
          </div>

        {formOpen && (
            <div
              className="overflow-y-auto fixed inset-0 h-full z-50 flex items-center justify-center bg-black bg-opacity-50"
              aria-hidden="true"
            >
              <div className="bg-white rounded-lg w-11/12 max-w-[40rem] max-h-[90vh] overflow-y-auto">
                
                <div className="flex justify-between items-center p-4 border-b">
                  <h5 className="text-lg font-medium">Place Offline Order</h5>
                  <button
                    type="button"
                    className="text-gray-600 text-3xl hover:text-gray-900"
                    onClick={toggleForm}
                  >
                    &times;
                  </button>
                </div>

                <div className="p-4">
                    <div className="w-full">
                        <form>
                            {selectedCategoryMenuImagesList.length > 0 ? (
                            selectedCategoryMenuImagesList.map((formFields, index) => (
                                
                                <React.Fragment key={index}>
                                <h4><b>{formFields.category_name}</b></h4>
                                {formFields.form_fields_serializer.map((field) => {
                                    const shouldHideField =
                                    (((field.additional_name === "starting_number" || field.additional_name === "numbering_location") && !numberingInk) ||
                                    ((field.additional_name === "sets_per_pad" || field.additional_name === "number_of_pads") && !padding) ||
                                    (field.additional_name === "number_of_sets" && !numberOfSet) ||
                                    ((["numbering_ink", "starting_number", "numbering_location"].includes(field.additional_name)) && !numbering)) &&
                                    formFields.category_additional_name === "carbonless_forms";

                                    const shouldShowOnlyField =
                                    (formFields.category_additional_name === "tickets" && ticketPaperColor && field.additional_name === "ticket_paper_color") ||
                                    (formFields.category_additional_name === "envelopes" && envelopeSize && ["window", "pull_&_seal"].includes(field.additional_name)) ||
                                    (formFields.category_additional_name === "flyer_5.5_x_8.5" && colorCopiesSellSheets && field.additional_name === "edge_cutting");

                                    if (shouldHideField || shouldShowOnlyField) return null;

                                    return (
                                    <div className="flex items-center justify-start w-full mb-4" key={field.id}>
                                        {/* Label and description tip */}
                                        <div className="flex relative items-center w-40 sm:w-44 md:w-48">
                                        <label
                                            htmlFor={field.field_name}
                                            className="block w-full text-left text-gray-600 font-medium flex items-center"
                                        >
                                            <span>{field.field_name}</span>
                                            {field.description && (
                                            <>
                                                <button
                                                ref={fieldTipButtonRef}
                                                onClick={(e) => handleToggleFieldTip(e, field.field_name)}
                                                className="ml-1 text-white bg-blue-600 hover:bg-blue-700 duration-300 ease-in-out transform hover:scale-105 p-[6px] rounded-full shadow-md flex items-center justify-center"
                                                style={{ width: "15px", height: "15px" }}
                                                title="Click to see more information"
                                                >
                                                ?
                                                </button>
                                                {openFieldTip === field.field_name && (
                                                <div
                                                    ref={fieldTipRef}
                                                    className="absolute shadow-lg top-8 left-4 z-20 p-4 border w-64 max-h-36 overflow-y-auto bg-white border-blue-500 text-gray-700 text-sm rounded-lg transition-all duration-300"
                                                >
                                                    <p>{field.description}</p>
                                                </div>
                                                )}
                                            </>
                                            )}
                                            <span className="ml-1">:</span>
                                        </label>
                                        </div>

                                        {/* Input or select */}
                                        <div className="flex gap-3 items-center justify-start w-64">
                                        {field.additional_name === 'quantity' && field.quantity_calculation ? (
                                            // Quantity input with custom arrows
                                            <div className="relative w-full max-w-md">
                                            <input
                                                type="number"
                                                name={field.field_name}
                                                // value={formData[field.field_name] || ''}
                                                value={formData[`${field.field_name}_${field.id}`] || ''}
                                                onChange={(e) => handleChange(e, field.id, field, formFields.category_id)}
                                                min={1}
                                                max={10000}
                                                step={1}
                                                className="block w-full p-3 pr-12 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                            />
                                            <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex flex-col space-y-1" style={{ fontSize: '10px' }}>
                                                <button
                                                type="button"
                                                onClick={() => {
                                                    const fieldKey = `${field.field_name}_${field.id}`;
                                                    handleChange(
                                                    {
                                                        target: {
                                                        name: field.field_name,
                                                        value: Math.min((Number(formData[fieldKey] || 0) + 25), 10000),
                                                        },
                                                    },
                                                    field.id,
                                                    field,
                                                    formFields.category_id
                                                    )
                                                }}
                                                className="text-gray-600 hover:text-orange-500"
                                                >
                                                ▲
                                                </button>
                                                <button
                                                type="button"
                                                onClick={() =>{
                                                    const fieldKey = `${field.field_name}_${field.id}`;
                                                    handleChange(
                                                    {
                                                        target: {
                                                        name: field.field_name,
                                                        value: Math.max((Number(formData[fieldKey] || 0) - 25), 1),
                                                        },
                                                    },
                                                    field.id,
                                                    field,
                                                    formFields.category_id
                                                    )
                                                }}
                                                className="text-gray-600 hover:text-orange-500"
                                                >
                                                ▼
                                                </button>
                                            </div>
                                            </div>
                                        ) : (
                                            // Regular select dropdown
                                            <select
                                            name={field.field_name}
                                            // value={formData[field.field_name] || ''}
                                            value={formData[`${field.field_name}_${field.id}`] || ''}
                                            onChange={(e) => handleChange(e, field.id, field, formFields.category_id)}
                                            className="block w-full p-2 border border-gray-300 rounded bg-white shadow-sm hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                            style={{
                                                maxHeight: '150px',
                                                overflowY: 'auto',
                                                appearance: field.additional_name === "number_of_sets" && perNumberOfPads.length === 2 ? 'none' : 'auto',
                                            }}
                                            disabled={field.additional_name === "number_of_sets" && perNumberOfPads.length === 2}
                                            >
                                            <option value="" disabled>Choose an option</option>
                                            {field.options &&
                                                (['Quantity', 'Photos'].includes(field.field_name)
                                                ? field.options
                                                    .slice()
                                                    .sort((a, b) => Number(a.name) - Number(b.name))
                                                    .map((option) => (
                                                        <option key={option.id} value={option.name}>{option.name}</option>
                                                    ))
                                                : field.options
                                                    .filter((option) =>
                                                        !(formFields.category_additional_name === 'brouchers' &&
                                                        field.additional_name === 'finish' &&
                                                        brouchers &&
                                                        option.name === 'High Gloss UV Coating')
                                                    )
                                                    .map((option) => (
                                                        <option key={option.id} value={option.name}>{option.name}</option>
                                                    )))}
                                            </select>
                                        )}
                                        </div>
                                    </div>
                                    );
                                })}
                                {formFields.price ? <h4 className="text-end"><b>Price: {formFields.price}</b></h4> : ''}
                                <hr />
                                <br />

                                </React.Fragment>
                            ))
                            ) : (
                            <div className='flex flex-col gap-2'>
                                {/* Loading skeleton */}
                                {[1, 2, 3].map((_, i) => (
                                <div key={i} className="flex items-center justify-start gap-8 w-full mb-4">
                                    <div className="w-20 sm:w-28 md:w-36 text-left text-gray-500 font-semibold">
                                    <Skeleton width='80%' height='25px' />
                                    </div>
                                    <div className='flex gap-3 items-center justify-start w-64'>
                                    <Skeleton width='100%' height='35px' />
                                    </div>
                                </div>
                                ))}
                            </div>
                            )}



                            <h4><b>User Details</b></h4>
                            <div className="flex flex-col justify-start w-full mb-4">
                              <div style={{width: '76%'}} className="flex items-center justify-start mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>Full Name</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                    <input
                                      type="text"
                                      name="fullName"
                                      placeholder="Full Name"
                                      value={orderUserDetails.fullName}
                                      onChange={handleOrderUserDetails}
                                      className="block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                    />
                                      </div>
                                  </div>
                              </div>
                              <div style={{width: '76%'}} className="flex items-center justify-start w-full mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>Email</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                    <input
                                      type="email"
                                      name="email"
                                      placeholder="Email"
                                      value={orderUserDetails.email}
                                      onChange={handleOrderUserDetails}
                                      className="block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                    />
                                      </div>
                                  </div>
                              </div>
                              <div style={{width: '76%'}} className="flex items-center justify-start w-full mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>Phone</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                    <input
                                      type="text"
                                      name="phone"
                                      placeholder="Phone"
                                      value={orderUserDetails.phone}  
                                      onChange={handleOrderUserDetails}
                                      className="block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                    />
                                      </div>
                                  </div>
                              </div>
                              <div style={{width: '76%'}} className="flex items-center justify-start w-full mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>Address</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                    <input
                                      type="text"
                                      name="address"
                                      placeholder="Address"
                                      value={orderUserDetails.address}
                                      onChange={handleOrderUserDetails}
                                      className="block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                    />
                                      </div>
                                  </div>
                              </div>
                              <div style={{width: '76%'}} className="flex items-center justify-start w-full mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>City</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                    <input
                                      type="text"
                                      name="city"
                                      placeholder="City"
                                      value={orderUserDetails.city}
                                      onChange={handleOrderUserDetails}
                                      className="block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                    />
                                      </div>
                                  </div>
                              </div>
                              <div style={{width: '76%'}} className="flex items-center justify-start w-full mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>State</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                    <input
                                      type="text"
                                      name="state"
                                      placeholder="State"
                                      value={orderUserDetails.state}
                                      onChange={handleOrderUserDetails}
                                      className="block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                    />
                                      </div>
                                  </div>
                              </div>

                              <div style={{width: '76%'}} className="flex items-center justify-start w-full mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>Zip Code</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                    <input
                                      type="text"
                                      name="zipCode"
                                      placeholder="Zip Code"
                                      value={orderUserDetails.zipCode}
                                      onChange={handleOrderUserDetails}
                                      className="block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                    />
                                      </div>
                                  </div>
                              </div>


                              {/* <div style={{width: '58%'}} className="flex items-center justify-start mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>Payment Mode</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                      <select
                                          name="paymentMode"
                                          value={orderUserDetails.paymentMode}
                                          onChange={handleOrderUserDetails}
                                          className="w-[177%] block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                        >
                                        <option value="" disabled>Choose an option</option>
                                        <option value="cash">Cash</option>
                                        <option value="check">Check</option>
                                        <option value="credit_card">Credit Card</option>
                                      </select>
                                     
                                    </div>
                                    <div className="relative w-full max-w-md">
                                       <button
                                          className="bg-blue-500 hover:bg-blue-400 duration-200 px-3 py-2 text-white rounded"
                                        >
                                          Submit Order
                                      </button>
                                    </div>
                                  </div>
                              </div> */}


                              <div style={{ width: '100%' }} className="flex items-center justify-start mb-4">
                                <label className="w-[33%] text-left text-gray-600 font-medium flex items-center">
                                  <span>Payment Mode</span>
                                  <span className="ml-1">:</span>
                                </label>

                                <div className="flex gap-4 items-center w-full">
                                  {/* Select Dropdown */}
                                  <select
                                    name="paymentMode"
                                    value={orderUserDetails.paymentMode}
                                    onChange={handleOrderUserDetails}
                                    className="w-[59%] ml-[44px] block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                  >
                                    <option value="" disabled>Choose an option</option>
                                    <option value="cash">Cash</option>
                                    <option value="check">Check</option>
                                    <option value="credit_card">Credit Card</option>
                                  </select>

                                  {orderUserDetails.paymentMode === 'credit_card' && 
                                    <button
                                      onClick={submitUserOrder}
                                      className="flex items-center bg-blue-500 hover:bg-blue-400 duration-200 px-4 py-2 text-white rounded whitespace-nowrap"
                                    >
                                      <MdGeneratingTokens className="mr-[7px]" /> Generate
                                    </button>
                                  }
                                </div>
                              </div>

                              {openLinkInput && orderUserDetails.paymentMode === 'credit_card' && 
                                <div style={{ width: '100%' }} className="flex items-center justify-start mb-4">
                                  <label className="w-[33%] text-left text-gray-600 font-medium flex items-center">
                                    <span>Payment URL</span>
                                    <span className="ml-1">:</span>
                                  </label>

                                  <div className="w-full flex items-start gap-2">
                                    <textarea
                                      name="paymentLinkTextAreaBox"
                                      placeholder="Payment Link URL"
                                      value={paymentLinkURL}
                                      rows={4}
                                      readOnly
                                      className="w-[59%] ml-[44px] p-2 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200 resize-none"
                                    />

                                    {/* <button
                                      onClick={copyToClipboard}
                                      title="Copy to clipboard"
                                      className="mt-1 p-2 bg-gray-200 hover:bg-gray-300 rounded text-gray-700"
                                    >
                                      <FiCopy size={20} />
                                    </button> */}

                                    <button
                                      onClick={sendPaymentURLMail}
                                      className="flex items-center ml-[7px] mt-[35px] bg-blue-500 hover:bg-blue-400 duration-200 px-4 py-2 text-white rounded whitespace-nowrap"
                                    >
                                      {loading ? (
                                          <FaSpinner className="mr-[7px] animate-spin" />
                                        ) : (
                                          <IoMdMail className="mr-[7px]" />
                                        )}
                                        {loading ? "Sending..." : "Send Mail"}
                                    </button>

                                  </div>
                                </div>
                              }
                              

                             

                              {orderUserDetails.paymentMode !== 'credit_card' && 
                                <div style={{width: '76%'}} className="flex items-center justify-start mb-4">
                                  <label
                                    className="block w-full text-left text-gray-600 font-medium flex items-center"
                                  >
                                    <span>Deposit Amount</span>
                                    <span className="ml-1">:</span>
                                  </label>
                                  <div className="flex gap-3 items-center justify-start w-64">
                                      <div className="relative w-full max-w-md">
                                      <input
                                        type="text"
                                        name="Depositamount"
                                        placeholder="Deposit Amount"
                                        value={orderUserDetails.Depositamount}
                                        onChange={handleOrderUserDetails}
                                        className="block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                      />
                                        </div>
                                    </div>
                                </div>
                              }
                              {orderUserDetails.paymentMode === 'check' &&
                                <div className="flex flex-col justify-start w-full mb-4">
                                  <div style={{width: '76%'}} className="flex items-center justify-start mb-4">
                                    <label
                                      className="block w-full text-left text-gray-600 font-medium flex items-center"
                                    >
                                      <span>{orderUserDetails.paymentMethod === 'credit_card' ? 'Transaction No' : 'Check No' }</span>
                                      <span className="ml-1">:</span>
                                    </label>
                                    <div className="flex gap-3 items-center justify-start w-64">
                                      <div className="relative w-full max-w-md">
                                        <input
                                          type="text"
                                          name="CheckCreditCardNo"
                                          placeholder={orderUserDetails.paymentMethod === 'credit_card' ? 'Transaction No' : 'Check No' }
                                          value={orderUserDetails.CheckCreditCardNo}
                                          onChange={handleOrderUserDetails}
                                          className="block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                            <hr /><br />




                            {/* <h4><b>Payment</b></h4>
                            <div className="flex flex-row p-2 justify-start w-full mb-4">
                              <div className="flex flex-row p-2 justify-start w-full mb-4 gap-8">
                                <label className="text-left text-gray-600 font-medium flex items-center">
                                  <input
                                    type="radio"
                                    name="paymentMethod"
                                    value="cash"
                                    checked={orderUserDetails.paymentMethod === "cash"}
                                    onChange={handleOrderUserDetails}
                                    className="mr-2"
                                  />
                                  Cash
                                </label>
                                <label className="text-left text-gray-600 font-medium flex items-center">
                                  <input
                                    type="radio"
                                    name="paymentMethod"
                                    value="credit_card"
                                    checked={orderUserDetails.paymentMethod === "credit_card"}
                                    onChange={handleOrderUserDetails}
                                    className="mr-2"
                                  />
                                  Credit Card
                                </label>
                                <label className="text-left text-gray-600 font-medium flex items-center">
                                  <input
                                    type="radio"
                                    name="paymentMethod"
                                    value="check"
                                    checked={orderUserDetails.paymentMethod === "check"}
                                    onChange={handleOrderUserDetails}
                                    className="mr-2"
                                  />
                                  Check
                                </label>
                              </div>
                            </div> */}

                            {/* {orderUserDetails.paymentMode === 'check' &&
                              <div className="flex flex-col justify-start w-full mb-4">
                                <div style={{width: '65%'}} className="flex items-center justify-start mb-4">
                                  <label
                                    className="block w-full text-left text-gray-600 font-medium flex items-center"
                                  >
                                    <span>{orderUserDetails.paymentMethod === 'credit_card' ? 'Transaction No' : 'Check No' }</span>
                                    <span className="ml-1">:</span>
                                  </label>
                                  <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                      <input
                                        type="text"
                                        name="CheckCreditCardNo"
                                        placeholder={orderUserDetails.paymentMethod === 'credit_card' ? 'Transaction No' : 'Check No' }
                                        value={orderUserDetails.CheckCreditCardNo}
                                        onChange={handleOrderUserDetails}
                                        className="block p-2 pr-10 border border-gray-300 rounded bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 duration-200"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            } */}

                            <h4><b>Total Price</b></h4>
                            <div className="flex flex-col p-2 justify-start w-full mb-4">
                              <div style={{width: '76%'}} className="flex items-center justify-start mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>Sub Total</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                      <span>{subTotal ? `$${subTotal}` : '$0.00'}</span>
                                    </div>
                                </div>
                              </div>
                              <div style={{width: '76%'}} className="flex items-center justify-start mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>Tax (8.875%)</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                      <span>{tax ? `$${tax}` : '$0.00'}</span>
                                    </div>
                                  </div>
                              </div>
                              <div style={{width: '76%'}} className="flex items-center justify-start mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>Grand Total</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                      <span>{grandTotal ? `$${grandTotal}` : '$0.00'}</span>
                                    </div>
                                  </div>
                              </div>
                              <div style={{width: '76%'}} className="flex items-center justify-start mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>Deposit Balance</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                      <span>{orderUserDetails.Depositamount ? `$${parseFloat(orderUserDetails.Depositamount).toFixed(2)}` : '$0.00'}</span>
                                    </div>
                                  </div>
                              </div>
                              <div style={{width: '76%'}} className="flex items-center justify-start mb-4">
                                <label
                                  className="block w-full text-left text-gray-600 font-medium flex items-center"
                                >
                                  <span>Balance Due</span>
                                  <span className="ml-1">:</span>
                                </label>
                                <div className="flex gap-3 items-center justify-start w-64">
                                    <div className="relative w-full max-w-md">
                                      <span>{balanceDue ? `$${balanceDue}` : '$0.00'}</span>
                                    </div>
                                  </div>
                              </div>
                            </div>
                        
                        </form>
                    </div>
                  <div className="flex justify-end items-center pt-4 border-t">
                    <button
                      type="button"
                      className="bg-red-500 hover:bg-red-400 duration-200 px-3 py-2 mr-3 text-white rounded"
                      onClick={toggleForm}
                    >
                      Close
                    </button>
                    {orderUserDetails.paymentMode !== 'credit_card' && 
                      <button
                        onClick={submitUserOrder}
                        className="bg-blue-500 hover:bg-blue-400 duration-200 px-3 py-2 text-white rounded"
                      >
                        Submit Order
                      </button>
                    }
                  </div>

                </div>
              </div>
            </div>
        )}


        







          <div className="bg-white mt-10 px-3 py-4 rounded-lg relative">
            <div className="flex justify-between">
            {/* <div className="flex justify-between fixed"> */}
              <div className="flex items-center gap-3 text-sm">
                <p className="text-neutral-500">Filter by Role:</p>
                <div className="card flex items-center gap-2">



                  <MultiSelect
                    id="OfflineMultiSelectId"
                    value={selectedMemorialCategoryId}
                    onChange={handleMemorialCategoryChange}
                    options={groupedMemorialCategories}
                    optionLabel="label"
                    optionGroupLabel="label"
                    optionGroupChildren="items"
                    optionGroupTemplate={groupHeaderTemplate}
                    display="chip"
                    placeholder="Memorial/Funeral"
                    className="p-2 focus:outline-none focus:border-blue-300 border w-full md:w-60"
                  />

                  <MultiSelect
                    id="OfflineMultiSelectId"
                    value={selectedMarketingEssentialsCategoryId}
                    onChange={handleMarketingEssentialsCategoryChange}
                    options={groupedmarketingEssentialsCategories}
                    optionLabel="label"
                    optionGroupLabel="label"
                    optionGroupChildren="items"
                    optionGroupTemplate={groupHeaderTemplate}
                    display="chip"
                    placeholder="Marketing Essentials"
                    className="p-2 focus:outline-none focus:border-blue-300 border w-full md:w-60"
                  />

                  <MultiSelect
                    id="OfflineMultiSelectId"
                    value={selectedSerivesCategoryId}
                    onChange={handleServicesCategoryChange}
                    options={groupedServicesCategories}
                    optionLabel="label"
                    optionGroupLabel="label"
                    optionGroupChildren="items"
                    optionGroupTemplate={groupHeaderTemplate}
                    display="chip"
                    placeholder="Services"
                    className="p-2 focus:outline-none focus:border-blue-300 border w-full md:w-60"
                  />



                {/* {allCategories.map((group, index) => {
                  const groupName = Object.keys(group)[0]; // e.g., "Memorial/Funeral"
                  const groupItems = group[groupName];     // Array of categories in that group

                  return (
                    <div key={index} className="mb-4">
                      <select
                        className="focus:outline-none focus:border-blue-300 border rounded px-2 py-1 w-full md:w-64"
                        onChange={(e) => handleGroupCategoryChange(e.target.value)}
                        defaultValue=""
                      >
                        <option value="" disabled>{groupName}</option>
                        {groupItems.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.category}
                          </option>
                        ))}
                      </select>
                    </div>
                  );
                })} */}
                  


                  <button
                    className="bg-blue-500 text-white py-2 px-3 rounded-full flex items-center hover:bg-blue-400"
                    onClick={getOfflineSelectedCategoryImages}
                  >
                    <FaEdit className="mr-[1px]" />
                    Submit
                  </button>
                </div>
              </div>

              <div className="fixed right-6 z-50 mr-[30px]">
                <button
                  className="bg-blue-500 text-white py-2 px-3 rounded-full flex items-center hover:bg-blue-400"
                  onClick={placeOfflineOrder}
                >
                  <FaEdit className="mr-[1px]" />
                  Place Order
                </button>
              </div>

            </div>
            {placeOrderValidationStatus && <p className="text-end text-[#ef5050]">Please select the product image.</p>}
            <div className="overflow-x-auto mt-[18px]">
              <hr />
              <div class="card-body">
                <div class="container mx-auto mt-8 px-4">
                  {selectedOfflineCategoryImages.length === 0 ? (
                    <p className="text-center text-gray-600">Please select the Category.</p>
                  ) : (
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                      {selectedOfflineCategoryImages.map((item) => {
                        const isClicked = clickedItems.some(
                          (clicked) => clicked.id === item.id
                        );
                        return (
                          <div
                            key={item.id}
                            className={`text-center p-2 rounded transition-shadow border border-gray-300 ${
                              isClicked ? "bg-blue-200 shadow-lg shadow-blue-500" : ""
                            }`}
                          >
                            <img
                              onClick={() => handleImageClick(item)}
                              src={item.image_file}
                              className="w-full mb-2 cursor-pointer rounded"
                              alt={`Image ${item.id}`}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineOrderImages;
